import styled from 'styled-components'

export const ReturnPortalContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => `${props.theme.spacing.sp8} ${props.theme.spacing.sp16}`};
  animation: fadeIn 0.3s;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.colors.info.surface};
  }
`

export const CheckIconContainer = styled.div`
  min-width: ${props => props.theme.size.S};
`

export const ReturnPortalLogo = styled.img`
  width: ${props => props.theme.size.L};
  height: ${props => props.theme.size.L};
  object-fit: contain;
  aspect-ratio: 1/1;
`
